(() => {
  if (window.AlawooderContact) {
    window.AlawooderContact.mount(document);
    return;
  }
  const mounted = new Map();

  function mount(section) {
    if (mounted.has(section)) return;
    const controller = new AbortController();
    const listen = (element, type, listener) => element?.addEventListener(type, listener, { signal: controller.signal });
    mounted.set(section, () => controller.abort());
    const form = section.querySelector('.ah-contact-form');
    const select = section.querySelector('[data-contact-select]');
    const topics = Array.from(section.querySelectorAll('[data-contact-topic]'));
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    const updateSelection = () => {
      topics.forEach(topic => {
        const current = Boolean(select?.value) && topic.dataset.contactTopic === select.value;
        topic.classList.toggle('is-current', current);
        if (current) topic.setAttribute('aria-current', 'true');
        else topic.removeAttribute('aria-current');
      });
    };

    topics.forEach(topic => {
      listen(topic, 'click', event => {
        if (!form || !select || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const value = topic.dataset.contactTopic;
        if (!Array.from(select.options).some(option => option.value === value)) return;
        event.preventDefault();
        select.value = value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        form.scrollIntoView({ block: 'start', behavior: reducedMotion.matches ? 'instant' : 'smooth' });
        select.focus({ preventScroll: true });
      });
    });
    listen(select, 'change', updateSelection);
    updateSelection();

    const feedback = section.querySelector('[data-contact-feedback]');
    if (feedback && !window.Shopify?.designMode) {
      feedback.focus({ preventScroll: true });
      feedback.scrollIntoView({ block: 'center', behavior: 'instant' });
    }
  }

  const mountWithin = root => {
    if (root.matches?.('[data-contact-section]')) mount(root);
    root.querySelectorAll?.('[data-contact-section]').forEach(mount);
  };
  window.AlawooderContact = { mount: mountWithin };
  mountWithin(document);
  document.addEventListener('shopify:section:load', event => mountWithin(event.target));
  document.addEventListener('shopify:section:unload', event => {
    mounted.forEach((cleanup, section) => {
      if (event.target === section || event.target.contains(section)) {
        cleanup();
        mounted.delete(section);
      }
    });
  });
})();
